<!--
 * @Date: 2019-07-04 11:25:07
 * @LastEditors: zwj
 * @LastEditTime: 2023-08-07 17:14:13
 -->
<template>
  <sidenav :orientation="orientation" :class="curClasses">
    <div class="app-brand demo justify-content-center" v-if="orientation !== 'horizontal'">
      <span class="app-brand-logo demo">
        <img class="w-100" src="/vendor/img/logo_w.png" alt="" srcset="" >
      </span>
    </div>
    <div class="app-brand justify-content-center text" v-if="orientation !== 'horizontal'">
      <!-- <p class="app-brand-text demo sidenav-text font-weight-normal ml-2 text-tiny">中共市委工委志愿者项目管理后台</p> -->
    </div>
    <div class="sidenav-divider mt-0" v-if="orientation !== 'horizontal'"></div>

    <div class="sidenav-inner" :class="{ 'py-1': orientation !== 'horizontal' }">
    
     <!-- 仪表盘 -->
      <!-- <template>
        <sidenav-router-link icon="fas fa-chart-line"  to="/dashboard">仪表盘</sidenav-router-link>
      </template> -->

      <template >
        <sidenav-menu icon="fas fa-flag" :active="isMenuActive('/activities')" :open="true">
          <template slot="link-text">市场活动一览</template>
          <template>
            <sidenav-router-link to="/activities/list" :exact="true">市场活动管理</sidenav-router-link>
          </template>
        </sidenav-menu>
      </template>
      
      <template>
        <sidenav-router-link icon="fas fa-building" to="/news/list" :exact="true">资讯管理</sidenav-router-link>
      </template>

      <template >
        <sidenav-router-link icon="fas fa-user-shield" to="/users/list" :exact="true">用户管理</sidenav-router-link>
      </template>


      <!-- 系统管理 -->
      <template >
        <sidenav-menu icon="fas fa-cog" :active="isMenuActive('/systeam_management')" :open="true" v-if="userInfo.roleId == 1">
          <template slot="link-text">系统管理</template>
          <template>
            <sidenav-router-link to="/systeam_management/super_setting" :exact="true">管理员设置</sidenav-router-link>
          </template>
          <template  >
            <sidenav-router-link to="/systeam_management/activity_classification" :exact="true">活动分类设置</sidenav-router-link>
          </template>
          <template  >
            <sidenav-router-link to="/systeam_management/activity_area" :exact="true">活动区域设置</sidenav-router-link>
          </template>
		  <template  >
            <sidenav-router-link to="/systeam_management/carousels" :exact="true">轮播图设置</sidenav-router-link>
          </template>
        </sidenav-menu>
      </template>

      <!-- <template>
        <sidenav-router-link icon="fas fa-calendar"  to="/data_statistics">数据统计</sidenav-router-link>
      </template> -->

      <!-- 安全审计 -->
      <template>
        <sidenav-menu icon="fas fas fa-user-lock" :active="isMenuActive('/security_audit')" :open="true">
          <template slot="link-text">安全审计</template>
          <template>
            <sidenav-router-link to="/security_audit/operation_logs" :exact="true">用户行为记录</sidenav-router-link>
          </template>
        </sidenav-menu>
      </template>

    </div>
  </sidenav>
</template>

<script>
import { Sidenav, SidenavRouterLink, SidenavMenu } from '@/vendor/libs/sidenav'

export default {
  name: 'app-layout-sidenav',
  components: {
    Sidenav,
    SidenavRouterLink,
    SidenavMenu
  },
  data(){
    return{
      userInfo: JSON.parse(localStorage.getItem('user_biz_info')).admin_info
    }
  },

  props: {
    orientation: {
      type: String,
      default: 'vertical'
    }
  },

  computed: {
    curClasses () {
      let bg = this.layoutSidenavBg

      if (this.orientation === 'horizontal' && (bg.indexOf(' sidenav-dark') !== -1 || bg.indexOf(' sidenav-light') !== -1)) {
        bg = bg
          .replace(' sidenav-dark', '')
          .replace(' sidenav-light', '')
          .replace('-darker', '')
          .replace('-dark', '')
      }

      return `bg-${bg} ` + (
        this.orientation !== 'horizontal'
          ? 'layout-sidenav'
          : 'layout-sidenav-horizontal container-p-x flex-grow-0'
      )
    }
  },

  methods: {
    isMenuActive (url) {
      return this.$route.path.indexOf(url) === 0
    },

    isMenuOpen (url) {
      return this.$route.path.indexOf(url) === 0 && this.orientation !== 'horizontal'
    },

    toggleSidenav () {
      this.layoutHelpers.toggleCollapsed()
    }
  }
}
</script>
